// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"hX-z","inlineTitle":"iX-z","sponsoredAdsWrapper":"jX-z","marketplaceRecosWrapper":"kX-z"};